import { ECoinTypeAvailabilityMode } from '../constants'

const getDefaultFromCode = (coinTypeAvailabilityModeFrom: ECoinTypeAvailabilityMode) =>
    coinTypeAvailabilityModeFrom === ECoinTypeAvailabilityMode.FIAT ? 'EUR' : 'BTC'

const getPairNameFromQuery = ({
    pair,
    coinCodeFrom,
    coinCodeTo,
    coinTypeAvailabilityModeFrom,
}: {
    pair: string
    coinCodeFrom: string
    coinCodeTo: string
    coinTypeAvailabilityModeFrom: ECoinTypeAvailabilityMode
}): string => {
    if (pair) return pair
    if (!coinCodeTo) return ''

    const calculatedCodeFrom = coinCodeFrom || getDefaultFromCode(coinTypeAvailabilityModeFrom)
    return `${coinCodeTo}${calculatedCodeFrom}`
}

const getPairQuery = ({
    pair,
    coinCodeFrom,
    coinCodeTo,
}: {
    pair: string
    coinCodeFrom: string
    coinCodeTo: string
}): string => {
    if (pair) return pair
    if (!coinCodeTo) return ''

    const defaultFrom = coinCodeFrom || 'USD'
    return `${coinCodeTo}${defaultFrom}`
}

export { getPairQuery, getPairNameFromQuery }
